import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login, error, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/", { replace: true });
  }

  if (user) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 relative overflow-hidden">
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(248,250,252,0.86), rgba(248,250,252,0.96)), url(https://images.unsplash.com/photo-1760092856749-31c8d5d28746?crop=entropy&cs=srgb&fm=jpg&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8 shadow-sm fade-up">
        <div className="flex flex-col items-center gap-2 mb-6">
          <img src="/logo.png" alt="Novo Auto" className="h-24 w-auto" />
          <div className="text-[10px] uppercase tracking-[0.22em] text-slate-500">CRM Showroom</div>
        </div>
        <h1 className="font-display text-3xl tracking-tight font-medium mb-1" data-testid="auth-title">
          Bine ai revenit
        </h1>
        <p className="text-sm text-slate-500 mb-6">Gestionează stocul, clienții și profitul mașinilor tale.</p>

        <form onSubmit={handleSubmit} className="space-y-3" autoComplete="on">
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-500">Email</label>
            <input
              data-testid="auth-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              autoComplete="email"
              placeholder="email@exemplu.ro"
              className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#0047FF]"
              required
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-500">Parolă</label>
            <input
              data-testid="auth-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#0047FF]"
              required
            />
          </div>

          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</div>}

          <button
            data-testid="auth-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-[#0047FF] hover:bg-[#003BD3] disabled:opacity-60 text-white font-medium py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
          >
            <Lock className="w-4 h-4" />
            {loading ? "Se procesează..." : "Autentificare"}
          </button>
        </form>

        <div className="mt-6 text-xs text-slate-400 text-center" data-testid="auth-no-signup-note">Conturile noi se creează de administrator.</div>
      </div>
    </div>
  );
}
